<template>
  <div
    class="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100"
  >
    <!-- Main Content -->
    <main class="max-w-7xl mx-auto px-6 py-8">
      <div
        class="relative bg-white rounded-2xl shadow-lg overflow-hidden border border-slate-200/50 h-screen max-h-[calc(100vh-180px)]"
      >
        <!-- Loading State -->
        <transition
          enter-active-class="transition-opacity duration-300"
          leave-active-class="transition-opacity duration-300"
          enter-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="loading"
            class="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 z-30 backdrop-blur-sm"
          >
            <div class="relative w-16 h-16 mb-4">
              <div
                class="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full animate-spin"
                style="clip-path: polygon(0 0, 100% 0, 100% 30%, 0 30%)"
              ></div>
              <div class="absolute inset-2 bg-white rounded-full"></div>
            </div>
            <p class="text-slate-600 font-medium">
              Loading your presentation...
            </p>
            <p class="text-sm text-slate-400 mt-2">This may take a moment</p>
          </div>
        </transition>

        <!-- Iframe -->
        <iframe
          :src="embedUrl"
          frameborder="0"
          allowfullscreen="true"
          class="w-full h-full transition-opacity duration-500"
          :class="{
            'opacity-0 pointer-events-none': loading,
            'opacity-100': !loading,
          }"
          @load="onIframeLoad"
        ></iframe>
      </div>

      <!-- Footer Info -->
      <div
        class="hidden md:block mt-6 p-4 bg-white rounded-xl border border-slate-200/50 shadow-sm"
      >
        <div class="flex items-center justify-between text-sm text-slate-600">
          <p>Fullscreen presentation view with smooth loading animation</p>
          <div class="flex items-center gap-2">
            <div
              class="w-2 h-2 rounded-full"
              :class="loading ? 'bg-yellow-400 animate-pulse' : 'bg-green-500'"
            ></div>
            <span class="text-xs">{{ loading ? "Loading" : "Connected" }}</span>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
  import { ref } from "vue";

  const embedUrl = ref(
    "https://docs.google.com/presentation/d/1nWhufo8v0yziFEZ1Kn_QPnhkI_D0flXaLzhg5zmEDSM/embed?start=false&loop=false&delayms=3000",
  );

  const loading = ref(true);

  const onIframeLoad = () => {
    loading.value = false;
  };
</script>

<style scoped>
  /* Smooth animations */
  @keyframes subtle-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .animate-spin {
    animation: subtle-spin 2.5s linear infinite;
  }
</style>
